import { clearSelectedAccountant, clearSelectedClient, clearSelectedTaxYear, setAppBarSelectedItem } from "../store/actions";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CountryService } from "../services/common/CountryService";
import FileSaver from "file-saver";
import { NoFoundPage } from "../pages/Anonymous/NoFoundPage";
import { ProvinceService } from "../services/ProvinceService";
import { format } from "date-fns";
import { printConsole } from "./http-commons";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

// const dispatch = useDispatch();
export const useNavigateToLogout = () => {
	const navigate = useNavigate();

	const NavigateToLogout = (path: string): void => {
		navigate(path);
	};

	return NavigateToLogout;
};

export const toCamelCase = (str: string): string =>
	str
		.trim()
		.split(/\s+/)
		.map((word, i) =>
			i === 0
				? word.toLowerCase()
				: word[0].toUpperCase() + word.slice(1).toLowerCase()
		)
		.join("");

export const formatDate = (datee: any) => {
	if (datee && datee !== "" && datee !== null) {
		const date = new Date(datee);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const formattedDate = `${year}-${month}-${day}`;

		return formattedDate;
	} else {
		return null;
	}
};

export const formatDateToShow = (datee: any) => {
	if (datee && datee !== "" && datee !== null) {
		const originalDate = new Date(datee);
		const formattedDate = format(originalDate, "MMM dd, yyyy");
		// const formattedDate = format(originalDate, "M dd, yy");
		return formattedDate;
	} else {
		return "";
	}
};

export const checkSINValidity = (inputNumber: string | any): number => {
	let result = 0;
	if (inputNumber) {
		for (let i = 0; i < inputNumber.length; i++) {
			const digit = parseInt(inputNumber[i], 10);

			// Multiply even digits by 2 and odd digits by 1
			let j = i + 1;
			const multiplier = j % 2 === 0 ? 2 : 1;
			const product = digit * multiplier;

			if (product.toString().length > 1) {
				const sumOfDigits = product
					.toString()
					.split("")
					.reduce((sum, num) => sum + parseInt(num, 10), 0);
				result += sumOfDigits;
			} else {
				result += product;
			}
		}
	}
	return result;
};

export const sortData = (data: any[]): any[] => {
	return data.sort((a, b) => a.label.localeCompare(b.label));
};
export const sortDDLByLabel = (data: any[]): any[] => {
	// return data.sort((a, b) => a.label.localeCompare(b.label));
	return data.sort((a, b) =>
		a.label?.trim().localeCompare(b.label?.trim())
	);
};
export const sortDragDropContextDDLByText = (data: any[]): any[] => {
	return data.sort((a, b) => a.text.localeCompare(b.text));
};
export const sortDragDropContextDDLByName = (data: any[]): any[] => {
	return data.sort((a, b) => a.name.localeCompare(b.name));
};
export const formatPhoneNo = (phone: any) => {
	if (phone && phone !== null && typeof phone === "string") {
		return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
	} else {
		return phone;
	}
};

export const formatThousandSeperatorWithTwoFixedAmount = (
	value: number | null | string
) => {
	if (typeof value === "string") {
		return value;
	} else if (value && value !== null) {
		return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	} else {
		return value;
	}
};

export const format422Errors = (errors: any) => {
	return errors.detail
		.map((error: any, index: any) => {
			// Extract the last key in the `loc` array as the field name
			const field = error.loc[error.loc.length - 1];
			// return `${index + 1}. ${field} ${error.msg}, `;
			return `${field} ${error.msg}, `;
		})
		.join("\n");
};

export const createRandomId = () => {
	let id = "";
	let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

	for (let i = 0; i < 5; i++) {
		id += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	return id;
};

export const addDashesInSIN = (sin: string) => {
	if (!sin) return "";
	const numericValue = sin.replace(/\D/g, "");
	const maxLength = Math.min(numericValue.length, 9);
	let formattedValue = "";

	for (let i = 0; i < maxLength; i++) {
		if (i === 3 || i === 6) formattedValue += "-";
		formattedValue += numericValue.charAt(i);
	}

	return formattedValue;
};

export const SINInputCell = ({
	rowData,
	rowIndex,
	field,
	tableData,
	setTableData,
	renderErrorClass,
}: {
	rowData: any;
	rowIndex: number;
	field: any;
	tableData: any[];
	setTableData: React.Dispatch<React.SetStateAction<any[]>>;
	renderErrorClass: (field: any, rowIndex: number, rowData: any) => string;
}) => {
	const [formattedValue, setFormattedValue] = useState(() =>
		addDashesInSIN(rowData.socialInsurance)
	);

	const handleValueChange = (value: string) => {
		const updatedValue = addDashesInSIN(value);
		setFormattedValue(updatedValue);

		const updatedData = [...tableData];
		updatedData[rowIndex][field.field] = value;
		setTableData(updatedData);
	};

	return (
		<input
			type="text"
			className={renderErrorClass(field, rowIndex, rowData)}
			value={formattedValue}
			onChange={(e) => handleValueChange(e.target.value)}
			maxLength={11}
			style={{ padding: "0.85rem" }}
		/>
	);
};

export enum EnhancedButtonPrimeReactSeverity {
	Primary = "", //blue
	Secondary = "secondary", //grey
	Success = "success", // greem
	Info = "info", //blue
	Warning = "warning", //musturd
	Help = "help", //purple
	Danger = "danger", //red
}
export const convertProvinceIdToObject = async (
	value: string,
	navigateToLogout: (path: string) => void
) => {
	if (value) {
		try {
			const countryList = await CountryService.getCountryDDL();
			if (countryList && Array.isArray(countryList)) {
				const canada = countryList.find(
					(item: any) => item.label === "Canada" || "canada"
				);
				if (canada) {
					const response = await CountryService.getProvinceOrStateDDL(
						navigateToLogout,
						canada.value,
						"Province"
					);
					const regenrateProvinceDDLItems = response.map(
						({ label, value, shortCode }: any) => ({
							name: label,
							id: value,
							shortCode,
						})
					);
					return regenrateProvinceDDLItems.filter((item: any) =>
						value.includes(item.id)
					);
				}
			}
		} catch (err) {
			console.error(err);
		}
	}
};

export const formatAmountCommaSeperator = (amount: number | string) => {
	if (amount == null || amount === "") return "0.00";
	const num = parseFloat(amount.toString());
	if (isNaN(num)) return "0.00";
	return num
		.toFixed(2) // 2 decimal places
		.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // comma separation
};

export const formatAmountToFloat = (amount: string) => {
	if (!amount) return 0;
	const cleaned = amount.replace(/[^0-9.-]/g, "");
	const num = parseFloat(cleaned);
	return isNaN(num) ? 0 : num;
};

// PrimeReact DataTable → when you navigate back, it first flashes the old cached rows, then replaces them after the API finishes → ❌ not what you want.

// That happens because PrimeReact DataTable is controlled by the value prop. If you’re holding rows in state and not clearing them when you leave/unmount the screen, it will re-render with old data immediately.
export const useRemoveQueriesOnUnmount = (queryKeys: string[]) => {
	const queryClient = useQueryClient();

	useEffect(() => {
		return () => {
			queryKeys.forEach((key) => {
				queryClient.removeQueries({ queryKey: [key] });
			});
		};
		// ✅ queryKeys is a stable array of strings, so no loop
	}, [queryClient, queryKeys.join("|")]);
};


export const getPayFrequencyLabelByGivingCode = (code: number | string | null | undefined): string | null => {
	if (code === null || code === undefined) {
		return null;
	}

	const payFrequencyMap: Record<string, string> = {
		"1": "1 - Annually",
		"2": "2 - Semi Annually",
		"4": "4 - Quarterly",
		"12": "12 - Monthly",
		"24": "24 - Semi Monthly",
		"26": "26 - Bi-Weekly",
		"27": "27 - Bi-Weekly",
		"52": "52 - Weekly",
		"53": "53 - Weekly",
		"22": "22 - Pay Periods", // default in your snippet
	};

	const key = String(code); // normalize to string
	return payFrequencyMap[key] ?? `${key} - Pay Periods`;
};


export const yesNoList = [
	{ label: "No", value: 100 },
	{ label: "Yes", value: 200 },
]
export const ShowHideList = [
	{ label: "Show", value: 200 },
	{ label: "Hide", value: 100 },
]

export const consoleValue = (label: any, value?: any): void => {
	if (!printConsole) return;

	// If only one argument (label string) is passed — just log it
	if (value === undefined) {
		console.log(label);
	} else {
		console.log(`${label}`, value);
	}
};

// export const findEmployeeOrSlip = (data: any, id: string) => {
// 	if (!Array.isArray(data)) return null;

// 	// 1. Check top-level employee objects
// 	const directMatch = data.find(item => item.value === id);
// 	if (directMatch) return { isSlipData: false, data: directMatch };

// 	// 2. Search inside totalSlips of each employee
// 	for (const item of data) {
// 		if (Array.isArray(item.totalSlips)) {
// 			const slipMatch = item.totalSlips.find((slip: any) => slip.id === id);
// 			if (slipMatch) return { isSlipData: true, data: slipMatch, selectedEmployee: item };
// 		}
// 	}
// 	return null;
// };
export const findEmployeeOrSlip = (data: any, id: string) => {
	if (!Array.isArray(data)) return null;

	// 1. Check top-level employee objects
	const directMatch = data.find(item => item.value === id);
	if (directMatch) return { isSlipData: false, data: directMatch };

	// 2. Search inside totalSlips of each employee
	for (const item of data) {
		if (Array.isArray(item.totalSlips)) {
			const slipMatch = item.totalSlips.find((slip: any) => slip.value === id);

			// console.log('slipMatchslipMatchslipMatch', slipMatch)
			// console.log('itemitemitemitemitemitemitemitem', item)
			if (slipMatch) return { isSlipData: true, data: slipMatch, selectedEmployee: item };
		}
	}
	return null;
};
export const getSlipTypeValueByLabel = (label: string) => {
	const options = [
		{ label: "Original", value: 400 },
		{ label: "Amended", value: 200 },
		{ label: "Cancelled", value: 300 },
		{ label: "Additional", value: 100 },
	];
	return options.find((item) => item.label === label)?.value;
};

export const base64ToPdfFile = (
	base64PDF: string,
	fileName: string = "document.pdf"
): File => {
	// Remove any data URL prefix if present
	const base64Data = base64PDF.includes(",")
		? base64PDF.split(",")[1]
		: base64PDF;

	// Convert Base64 to binary data
	const byteCharacters = atob(base64Data);
	const byteNumbers = new Array(byteCharacters.length);

	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}

	// Create a Uint8Array from the binary data
	const byteArray = new Uint8Array(byteNumbers);

	// Create a Blob object with the MIME type for PDF
	const blob = new Blob([byteArray], { type: "application/pdf" });

	// Create and return a File object
	return new File([blob], fileName, { type: "application/pdf" });
};

export const savePdfAsFile = (pdfData: any, filename: any) => {
	const blob = new Blob([pdfData], { type: "application/pdf" });
	FileSaver.saveAs(blob, filename);
}
export const saveXlsxAsFile = (data: any, filename: string) => {
	const blob = new Blob([data], {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	});
	FileSaver.saveAs(blob, filename);
};

export const downloadBase64Txt = (base64Data: string, filename: string) => {
	// decode base64
	const decodedData = atob(base64Data);

	// convert to Uint8Array
	const byteNumbers = new Array(decodedData.length);
	for (let i = 0; i < decodedData.length; i++) {
		byteNumbers[i] = decodedData.charCodeAt(i);
	}

	const byteArray = new Uint8Array(byteNumbers);

	const blob = new Blob([byteArray], { type: "text/plain;charset=utf-8" });

	FileSaver.saveAs(blob, filename);
};

export const getValueByFieldPath = (obj: any, path: string) => {
	if (!obj || !path) return undefined;

	return path.split('.').reduce((acc, key) => {
		if (acc && acc[key] !== undefined) {
			return acc[key];
		}
		return undefined;
	}, obj);
}


export const roleTypeForUserDDL = [
	{ label: "Direct Client", value: 200 },
	{ label: "Accounting Professional", value: 100 }
]

export const accountTypeDDL = [
	{ label: "Accountant", value: 100 },
	{ label: "Admin", value: 200 },
	{ label: "Super User", value: 300 },
]



export const extractMenuUrls = (menu: any[]): string[] => {
	const urls: string[] = [];

	const traverse = (items: any[]) => {
		items.forEach(item => {
			if (item.url) {
				urls.push(item.url);
			}
			if (item.items?.length) {
				traverse(item.items);
			}
		});
	};

	traverse(menu);
	return urls;
};

export const RoleRouteGuard: any = ({ menuList, isAdminUser, children }: any) => {
	const location = useLocation();
	if (isAdminUser === 400) {
		return <>{children}</>;
	}

	const allowedUrls = useMemo(
		() => extractMenuUrls(menuList),
		[menuList]
	);

	const isAllowed = allowedUrls.some(url =>
		location.pathname === url ||
		location.pathname.startsWith(`${url}/`)
	);

	if (!isAllowed) {
		return <NoFoundPage />;
	}

	return <>{children}</>;
};

export const getDDLValueByLabel = (
	list: any[],
	label: string
): any => {
	if (!Array.isArray(list) || !label) return label;

	const match = list.find(
		item => item.label?.toLowerCase() === label.toLowerCase()
	);

	return match ? match.value : label;
};
export const getProvinceDDLValueByShortCode = (
	list: any[],
	shortCode: string
): any => {
	if (!Array.isArray(list) || !shortCode) return shortCode;

	const match = list.find(
		item => item.shortCode?.toLowerCase() === shortCode.toLowerCase()
	);

	return match ? match.value : shortCode;
};
export const getProvinceDDLLabelByShortCode = (
	list: any[],
	shortCode: string
): any => {
	if (!Array.isArray(list) || !shortCode) return shortCode;

	const match = list.find(
		item => item.shortCode?.toLowerCase() === shortCode.toLowerCase()
	);

	return match ? match.label : shortCode;
};
export const getDDLLabelByValue = (
	list: any[],
	value: string
): any => {
	if (!Array.isArray(list) || !value) return value;

	const match = list.find(
		item => item.value?.toLowerCase() === value.toLowerCase()
	);

	return match ? match.label : value;
};

export const getDDLLabelByValueForDraftEmployee = (
	list: any[],
	value: string
): any => {
	if (!Array.isArray(list) || !value) return value;

	const match = list.find(
		item => item.value?.toLowerCase() === value.toLowerCase()
	);

	return match ? match.label : null;
};
export const getDDLValueByLabelForDraftEmployee = (
	list: any[],
	value: string
): any => {
	if (!Array.isArray(list) || !value) return value;

	const match = list.find(
		item => item.label?.toLowerCase() === value.toLowerCase()
	);

	return match ? match.label : null;  //umair
};


// Date field validation helper function
export const isMasked = (value: any) =>
	typeof value === "string" && value.charAt(2) === "*";

export const isValidDate = (value: any) => {
	const date = new Date(value);
	return !isNaN(date.getTime());
};

export const isAtLeast10YearsOld = (value: any) => {
	const date = new Date(value);
	const minDate = new Date();
	minDate.setFullYear(minDate.getFullYear() - 10);
	return date <= minDate;
};

export const scrollPanelFieldsToTop = () => {
	window.scrollTo({ top: 0, behavior: "smooth" });
};

export const convertFileToBase64 = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = (error) => reject(error);
	});
};

export const formatNumberToMaximumTenCharacters = (num: any, length = 10) => String(num).padStart(length, '0');

export const showDashesInSIN = (sin: string) => sin.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatTimestamp = (raw: any) => {
	const d = new Date(raw.trim());
	if (isNaN(d.getTime())) return null;

	const mon = MONTHS[d.getMonth()];
	const day = d.getDate();
	const yr = d.getFullYear();
	let hr = d.getHours();
	const min = String(d.getMinutes()).padStart(2, "0");
	const ampm = hr >= 12 ? "PM" : "AM";
	hr = hr % 12 || 12;

	return `${mon} ${day} ${yr} ${hr}:${min} ${ampm}`;
	// → "Jun 22 2026 12:12 PM"
}


const INTEGRATION_NAME_MAP: Record<string, string> = {
	net_suite: "NetSuite",
	zoho_books: "Zoho Books",
	xero: "Xero",
	quick_books: "QuickBooks",
	kashoo: "Kashoo",
	taxslips: "Taxslips",
	toggl: "Toggl",
	agendrix: "Agendrix",
	when_i_work: "When I Work",
	swipe_clock: "SwipeClock",
	zoho_people: "Zoho People",
	easy_work_force: "EasyWorkforce",
	quick_books_time: "QuickBooks Time",
	work_flow_max: "WorkflowMax",
	seven_shifts: "7Shifts",
	humanity: "Humanity",
	deputy: "Deputy",
	hr_wize: "HRWize",
	workable: "Workable",
	namely: "Namely",
	bamboo_hr: "BambooHR",


	hr_zoho_people: "Zoho People ",
	st_zoho_books: "Zoho Books ",
};
export const getAddOnsScreenParentName = (slug: string): string => {
	if (INTEGRATION_NAME_MAP[slug]) {
		return INTEGRATION_NAME_MAP[slug];
	}

	// Fallback: title-case each word, joined with spaces
	return slug
		.split("_")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

export const getItemsLength = (arr?: any[]) => arr?.length ?? 0;